import React from "react";

const arnav_singhal = () => {
  return (
    <div>
      <h1>Arnav Singhal</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Only students with a CGPA of 7.5 or above and no backlogs were eligible
        to appear for the aptitude test. Candidates were shortlisted for
        interviews based on their performance in the test.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?{" "}
      </p>

      <p>
        Interviews were conducted the day after the aptitude test, on 30th
        September 2025. The structure of the interview process for each team was
        as follows:
      </p>

      <ul>
        <li>
          <strong>LCS:</strong> 2 Technical interviews followed by 1 HR
          interview{" "}
        </li>
        <li>
          <strong>Mendix:</strong> 1 Technical interview followed by 1 combined
          Technical+HR interview{" "}
        </li>
        <li>
          <strong>DM:</strong> 1 Technical interview
        </li>
      </ul>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude test was conducted on 29th September, 2025. It consisted of
        24 questions and had a duration of 1 hour and 20 minutes. The questions
        covered quantitative aptitude, logical reasoning, code comprehension (in
        C/C++, JavaScript, Java, etc.) and Object-Oriented Programming (OOPS)
        concepts.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />A total of 51 students were shortlisted after the aptitude round.
        Candidates were then assigned to one of the three teams hiring for the
        PLM Engineer Intern position as follows:
      </p>

      <ul>
        <li>LCS: 35 students </li>
        <li>Mendix: 11 students </li>
        <li>DM: 5 students</li>
      </ul>

      <p>
        Team assignments were done by the company based on an assessment of each
        candidate’s resume, and we were not allowed to submit our preferences. I
        was assigned to the Mendix team.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was released a few hours after the aptitude test, and
        interviews were scheduled for the very next day, leaving a very short
        window for preparation. During this time, I focused on revising core
        subjects such as DSA, OOPS, OS and DBMS. I also revisited some coding
        problems on LeetCode, and practised logical reasoning questions from
        IndiaBix and GeeksforGeeks. Additionally, I prepared for the HR
        interview by framing answers to commonly asked questions.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
      </p>

      <p>For the Mendix team, there were two interview rounds:</p>

      <p>
        <strong>Round 1 (Technical):</strong>
        <br />
        This round lasted for about 45 minutes. It began with a brief
        self-introduction, followed by questions to understand my interests in
        different domains, particularly web technologies. I was then asked to
        write pseudocode for a basic FIFO implementation. The discussion later
        shifted to my coursework, where I was asked about the mathematics
        courses I had studied. Since I’m the Digital Signal Processing Subsystem
        Head for the COEP Astronomy Club’s Radio Telescope project, the
        interviewer asked a few questions about Fourier transforms and how I’ve
        applied mathematical concepts in computer science contexts.
        <br />
        Next, I was asked some questions related to Operating Systems concepts.
        I was also asked to explain how one could programmatically evaluate the
        time complexity of a graph pathfinding algorithm. The round concluded
        with a brief discussion on React, JavaScript and TypeScript.
      </p>

      <p>
        <strong>Round 2 (Technical+HR):</strong>
        <br />
        Out of the 11 students shortlisted for the previous round, 4 were
        selected for this one. This round lasted for around 25-30 minutes. It
        began with another self-introduction, followed by questions about why I
        chose to study computer science, what computer engineering means to me,
        and how I aspire to contribute to the field. I was also asked where I
        see myself five years from now. The interviewer then presented a data
        structures-based problem related to sorting strings distributed across{" "}
        <em>n</em> files. We also discussed my research project at IUCAA, which
        involved studying the feasibility of AI/ML techniques in job scheduling
        for high-throughput computing systems.
        <br />
        The discussion later shifted to personal topics, where I was asked about
        my family background and extracurricular involvement, particularly my
        role at COEP’s Wellness Centre मित्र. I spoke about the importance of
        spreading mental health awareness and was asked whether I would continue
        contributing to the cause even after achieving professional success, to
        which I replied affirmatively. The round concluded on that note.
      </p>

      <p>In the end, 3 students were offered the internship.</p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The interviewers focused on a mix of technical and behavioural topics.
        In the first round, the emphasis was on data structures and algorithms,
        operating systems and mathematical knowledge relevant to real-world
        applications. Additionally, as mentioned earlier, there was a brief
        discussion on web technologies.
      </p>

      <p>
        In the second round, the focus expanded to include both technical and HR
        aspects. The technical questions primarily tested DSA concepts and
        problem-solving ability. However, this round largely focused on
        assessing communication skills, motivation, long-term goals and
        involvement in projects and extracurricular activities.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        DSA: Striver’s A2Z DSA Sheet
        <br />
        OS: Operating Systems by Galvin, Abhijit sir’s lecture recordings
        (available on YouTube)
        <br />
        DBMS: Love Babbar Placement Series
        <br />
        Quantitative Aptitude / Logical Reasoning: IndiaBix, GeeksforGeeks
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
      </p>

      <ol>
        <li>
          <strong>Consistency matters:</strong> Set aside some time everyday to
          solve problems, and gradually build speed and accuracy.{" "}
        </li>
        <li>
          <strong>Cover a variety of topics:</strong> Practise different types
          of questions so that you learn to identify common patterns and problem
          types.{" "}
        </li>
        <li>
          <strong>Start simple, then optimise:</strong> Begin with a brute-force
          approach to show that you understand the problem, and then refine your
          solution for efficiency.{" "}
        </li>
        <li>
          <strong>Explain your reasoning:</strong> Interviewers value clarity of
          thought and how you approach a problem more than whether you
          immediately reach the most optimal answer.
        </li>
      </ol>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />I was asked around four or five questions related to my projects
        and extracurricular activities. In the first round, the interviewer
        asked about my role as the Digital Signal Processing Subsystem Head for
        the COEP Astronomy Club’s Radio Telescope project and discussed the
        application of mathematical concepts like Fourier transforms in computer
        science. In the second round, I was asked about my research project at
        IUCAA on applying AI/ML techniques to job scheduling in high-throughput
        computing systems, as well as my involvement with COEP’s Wellness Centre
        मित्र and my views on mental health awareness.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Siemens interviewers are friendly and focus more on understanding your
        thought process rather than expecting textbook-perfect answers. So, stay
        calm, communicate clearly, and be honest if you don’t know something.
        Make sure your basics in DSA and other core subjects are solid.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        1. Don’t wait until the last minute to start preparing. Consistency is
        key.
        <br />
        2. Have at least one solid project that you can confidently discuss.
        <br />
        3. While preparing for interviews, focus on clarity and understanding
        over memorization.
        <br />
        4. Lastly, don’t compare your progress with others. Everyone’s path is
        different.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 9049005201
        <br />
        <strong>Email :</strong> <a href="mailto:arnavs22.comp@coeptech.ac.in">arnavs22.comp@coeptech.ac.in</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/arnav-singhal-07338a25b/">
          {" "}
          Arnav Singhal
        </a>
      </p>

      <hr />
    </div>
  );
};

export default arnav_singhal;
